import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'coming-soon-page',
    templateUrl: './coming-soon-page.component.html',
    standalone: false
})
export class ComingSoonPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
